import { createRoute, Link } from '@tanstack/react-router'
import { Button, EmptyState } from '@volee/ui'

import { useSignOut } from '../data/use-sign-out.ts'
import { messages } from '../messages/index.ts'
import { rootRoute } from './root.tsx'
import { NAV_PATHS } from '../navigation/paths.ts'

// Where an authenticated user without the role ends up — distinct from the login, which for
// them would be a loop (apps/frontend/docs/razionale-che-il-codice-indica.md).
export const forbiddenRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: NAV_PATHS.forbidden,
  staticData: { chrome: 'bare' },
  component: Forbidden,
})

function Forbidden() {
  const signOut = useSignOut()

  return (
    <EmptyState
      title={messages.forbidden.title}
      description={messages.forbidden.description}
      action={
        <div className="flex flex-wrap items-center justify-center gap-2">
          <Button asChild>
            <Link to={NAV_PATHS.home}>{messages.forbidden.backToHome}</Link>
          </Button>
          {/* An account with no facet is sent here BY `/`, so «back to the home page» would
              bounce it straight back: signing out is the only way forward it has. */}
          <Button variant="outline" onClick={() => void signOut()}>
            {messages.forbidden.signOut}
          </Button>
        </div>
      }
    />
  )
}
